
import { Component, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';
import { CheckoutPaymentData } from './checkoutPayment.vue';
import Navigation from '@shared/components/navigation/navigation.vue';
import Container from '@shared/components/container/container.vue';
import CircleIcon from '@shared/components/container/circleIcon.vue';
import CheckoutPayWithVouchers from './checkoutPayWithVouchers.vue';
import CheckoutPaymentMethods from './checkoutPaymentMethods.vue';
import PubliCheck from '@shared/components/publiCheck/publiCheck.vue';
import LegalCheck from "@shared/components/legalCheck/legalCheck.vue";
import TriggerAnchor from '@shared/components/triggerAnchor/triggerAnchor.vue';
import CheckoutFooter from './checkoutFooter.vue';

@Component({
  components: {
    Navigation,
    CheckoutPayment,
    CheckoutPayWithVouchers,
    CheckoutPaymentMethods,
    CheckoutFooter,
    Container,
    CircleIcon,
    LegalCheck,
    PubliCheck,
    TriggerAnchor,
  },
})
export default class CheckoutPayment extends Vue {
  @Prop({ required: true }) private data!: CheckoutPaymentData|null;
  @Prop() private transport!: any;
  @Prop({ required: true }) private cid!: any;
  @Prop({ default: {promoCode: "", discount: 0, netDiscount: 0, discountedTaxes: 0} })
  private discountInfo!: {promoCode: string, discount: number, netDiscount: number, discountedTaxes: number};

  private acceptConditions: boolean = false;
  private okRss: boolean = false;
  private error: string|null = null;

  mounted() {
    this.okRss = this.data?.okRss ?? false;
    this.acceptConditions = this.data?.acceptConditions ?? false;
  }

  private async checkout() {
    await (this.$refs['paymentMethods'] as CheckoutPaymentMethods).checkout(false);
  }
}
